export default __webpack_public_path__ + "static/media/course.8e2ca470.svg";